'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 579
// module chunks = 47